import { render, staticRenderFns } from "./SetupForm.vue?vue&type=template&id=765310a3&scoped=true"
import script from "./SetupForm.vue?vue&type=script&lang=js"
export * from "./SetupForm.vue?vue&type=script&lang=js"
import style0 from "./SetupForm.vue?vue&type=style&index=0&id=765310a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765310a3",
  null
  
)

export default component.exports